import {svgIconWrapper} from '../svg-icon-wrapper';

import InstagramRegular from './instagram-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <InstagramRegular {...props} />;
}

SvgComponent.iconName = 'instagramRegular';

export const InstagramRegularIcon = svgIconWrapper(SvgComponent);
